import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  sectionHeading: {
    fontFamily: theme.typography.fontFamily,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.15px',
  },
  sectionContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(2.25),
    width: '100%',
  },
  errorMessage: {
    color: theme.palette.error.dark,
    fontSize: '12px',
    marginTop: theme.spacing(1),
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '16px',
  },
}))
